import { Component, computed, inject, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { filter } from 'rxjs/operators';
import { RouterOutlet } from '@angular/router';
import { FsnLoading } from '@ford-fusion/angular';
import { InteractionStatus } from '@azure/msal-browser';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { TranslocoService } from '@jsverse/transloco';
import { PendoService } from './core/service/pendo.service';
import { LoaderStore } from './core/store/loader.store';
import { AzureAdTokenClaims } from './shared/models/azure-ad-token-claims.interface';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FsnLoading],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Sin SA Frontend';

  private readonly loaderStore = inject(LoaderStore);
  private readonly transloco = inject(TranslocoService);
  private readonly msalService = inject(MsalService);
  private readonly msalBroadcastService = inject(MsalBroadcastService);
  private readonly pendoService = inject(PendoService);

  isLoading = computed(() => {
    return this.loaderStore.isLoading();
  });

  ngOnInit() {
    this.transloco.setActiveLang('pt-BR');
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        take(1),
      )
      .subscribe(() => this.initializePendo());
  }

  private initializePendo(): void {
    const account =
      this.msalService.instance.getActiveAccount() ??
      this.msalService.instance.getAllAccounts()[0];
    const cdsId = account?.username?.split('@')[0];
    const claims = account?.idTokenClaims as AzureAdTokenClaims | undefined;

    if (cdsId) {
      this.pendoService.initialize({ id: cdsId, country: claims?.country });
    }
  }
}
